import { Star } from "lucide-react";
import { GOOGLE_REVIEWS } from "../data/site";
import VisitorCounter from "./VisitorCounter";

const REVIEWS = [
  { name: "Ayşe K.", text: "Bali masajı harikaydı, mekan çok temiz ve huzurlu. Kesinlikle tekrar geleceğim.", service: "Bali Masajı" },
  { name: "Mehmet D.", text: "Sporcu masajı sonrası tüm gerginliğim gitti. Personel çok ilgili ve profesyonel.", service: "Sporcu Masajı" },
  { name: "Zeynep A.", text: "Sivas'ta böyle kaliteli bir spa bulmak şaşırttı. Sultan masajı muhteşem bir deneyim.", service: "Sultan Masajı" },
  { name: "Emre T.", text: "Medikal masaj için geldim, boyun ağrılarım ciddi şekilde azaldı. Herkese tavsiye ederim.", service: "Medikal Masaj" },
  { name: "Elif S.", text: "Sauna ve jakuzi sonrası masaj kombinasyonu mükemmel. Randevu sistemi çok pratik.", service: "Sauna & Jakuzi" },
  { name: "Burak Y.", text: "Thai masajını ilk kez denedim, çok memnun kaldım. Ortam sakin ve hijyenik.", service: "Thai Masajı" },
];

const Stars = () => (
  <span className="rev-stars" aria-hidden="true">
    {[0, 1, 2, 3, 4].map((i) => <Star key={i} size={13} fill="currentColor" />)}
  </span>
);

export default function ReviewsSlider() {
  return (
    <section className="reviews" data-testid="reviews-section">
      <div className="reviews-head">
        <a className="rev-badge" href={GOOGLE_REVIEWS} target="_blank" rel="noreferrer" data-testid="google-rating-badge">
          <span className="rev-score">4.9</span>
          <span className="rev-badge-info">
            <Stars />
            <small>100+ Google yorumu</small>
          </span>
        </a>
        <p className="reviews-title">Misafirlerimiz ne diyor?</p>
        <VisitorCounter />
      </div>
      <div className="rev-window" aria-hidden="true">
        <div className="rev-track">
          {[0, 1].map((half) => (
            <div className="rev-half" key={half}>
              {REVIEWS.map((r, i) => (
                <article className="rev-card" key={`${half}-${i}`} data-testid={half === 0 ? `review-card-${i}` : undefined}>
                  <Stars />
                  <p>{r.text}</p>
                  <footer>
                    <strong>{r.name}</strong>
                    <small>{r.service} · Google Yorumu</small>
                  </footer>
                </article>
              ))}
            </div>
          ))}
        </div>
      </div>
      <a className="reviews-link" href={GOOGLE_REVIEWS} target="_blank" rel="noreferrer" data-testid="reviews-link">
        Tüm yorumları Google'da gör
      </a>
    </section>
  );
}
